import React from 'react';
import BusinessOutlined from '@mui/icons-material/BusinessOutlined';
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import StatCard from '../StatCard'

const CardEmpresas = (props) => {
  const totalEmpresas = useSelector((state) => state.dashboard?.dashboard?.totalEmpresas)

  return (
    <StatCard
      {...props}
      label="Total de empresas cadastradas"
      value={totalEmpresas ? totalEmpresas : 0}
      icon={<BusinessOutlined />}
    />
  );
}

CardEmpresas.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
}

export default CardEmpresas
